import styled from '@emotion/styled';
import { InputWithIcons as InputWithIconsTK } from '@tablecheck/tablekit-react';

export const InputWithIcons = styled(InputWithIconsTK)`
  grid-template-columns: 8px 16px auto 48px;

  & > input,
  & > select {
    grid-area: 1/1/1/4;

    &:first-child:not(:last-child),
    &:not(:first-child):last-child {
      padding-left: calc(16px);
      padding-right: calc(16px);
    }
    &:not(:first-child):not(:last-child) {
      padding: 12px 16px;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
  }

  & > button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    &:focus:not(:focus-visible),
    &:focus-visible {
      outline: none;
      &:after {
        content: none;
        position: absolute;
      }
    }
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l1);
`;
